// This file is automatically generated. Do not edit manually.

import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DeliveryPrintoutApi {
	export async function printDeliveryConsignmentNote(args: {
		deliveryId: number;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/printDeliveryConsignmentNote",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printDeliveryPackingSlip(args: { deliveryId: number }): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/printDeliveryPackingSlip",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printDeliveryNote(args: { deliveryId: number }): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/printDeliveryNote",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printDeliveryConsignmentNoteForCargoDriver(args: {
		deliveryId: number;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/printDeliveryConsignmentNoteForCargoDriver",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printDeliveryPackingSlipForCargoDriver(args: {
		deliveryId: number;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/printDeliveryPackingSlipForCargoDriver",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printDeliveryNoteForCargoDriver(args: {
		deliveryId: number;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/printDeliveryNoteForCargoDriver",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}
}
